export function Blurb({ blurb }: { blurb?: string | null }) {
  if (!blurb) return null
  return (
    <div className="rounded-md border bg-muted p-3">
      <q className="text-sm font-light italic">{blurb}</q>
    </div>
  )
}
